import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import routes from './utils/routes';
import { languageManager } from './utils/i18n';
import './styles/variables.css';
import './styles/global.css';

const App = () => {
  const [language ,setLanguage] = useState(languageManager.getCurrentLanguage());

  useEffect(() => {
    const handleLanguageChange = () => {
      setLanguage(languageManager.getCurrentLanguage());
    };

    window.addEventListener('languageChanged', handleLanguageChange);

    return () => {
      window.removeEventListener('languageChanged', handleLanguageChange);
    };
  }, []);

  return (
      <Router>
        <div className="app">
          <Header />
          <main>
            <Routes>
              {routes.map((route) => (
                  <Route
                      key={route.path}
                      path={route.path}
                      element={<route.component />}
                      exact={route.exact}
                  />
              ))}
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
  );
};

export default App;